export default __webpack_public_path__ + "static/media/img6.ee598cb0.svg";